import React from 'react';

//styles
import { IconWrapper, IconsWrapper } from 'components/common/Table/index.styled';
//assets
import { PencilIcon } from 'assets/icons';

interface IEditTableIcon {
  setSideBar: (s: boolean) => void;
}

export const EditTableIcon = ({ setSideBar = () => null }: IEditTableIcon) => {
  return (
    <IconsWrapper>
      <IconWrapper onClick={() => setSideBar(true)}>
        <PencilIcon />
      </IconWrapper>
    </IconsWrapper>
  );
};
